import { useQuery } from "@tanstack/react-query";
import { queryEventByID } from "supabase/events";

type UseQueryEventParams = {
  uid: string;
};

export const useQueryEvent = (params: UseQueryEventParams) => {
  const { uid } = params;

  const {
    isLoading,
    isError,
    error,
    data: event,
  } = useQuery({
    queryKey: ["event", uid],
    queryFn: () => {
      return queryEventByID({ uid });
    },
  });

  return { isLoading, isError, error, event };
};
